export type AnnouncementDisplayOption = 'ALL_LIBRARY' | 'HOMEPAGE';

export enum AnnouncementType {
  NONE = 'NONE',
  EXTERNAL = 'EXTERNAL',
  FILE = 'FILE',
  MEDIA = 'MEDIA',
}

export interface Translation {
  title: string;
  localeId: number;
}

export interface Announcement {
  id?: number | null;
  title: string;
  fromDate: number;
  toDate?: number | null;
  enabled: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface AnnouncementAdminResponse extends Announcement {
  type: AnnouncementType; // Type of the announcement
  displayOption: AnnouncementDisplayOption | null;
  barColor: string | null; // Hex color code; default to banner color
  textColor: string | null; // Hex color code; default to inverted banner color
  attachmentName?: string | null; // Optional name for FILE type
  externalUrl?: string | null; // Optional URL for EXTERNAL type
  targetMediaIdentifier?: string | null; // Optional identifier for MEDIA type
  assignedOrganizations: number[]; // List of organization IDs, can be empty
  translations: Translation[]; // Must contain at least one translation
}

export type AnnouncementSortField = 'title' | 'fromDate' | 'toDate' | 'enabled';
export type SortDirection = 'asc' | 'desc';

export interface AnnouncementSortOptions {
  field: AnnouncementSortField;
  direction: SortDirection;
}

export interface AnnouncementFilterCriteria {
  search?: string;
  limit?: number;
  offset?: number;
  sortField?: AnnouncementSortField;
  sortDirection?: SortDirection;
}

// New search result item type
export interface AnnouncementSearchItemDto extends Announcement {
  // Additional fields specific to search results can be added here
}

// Updated response structure
export interface AnnouncementSearchResponse {
  totalCount: number;
  matchCount?: number;  // New optional field
  limit: number;
  offset: number;
  items: AnnouncementSearchItemDto[];  // Updated to use the specific DTO type
}
